module.exports = __webpack_public_path__ + "img/nav_img_supplement_2025.ef6c4023.png";